import { jobLogger } from '../behavior/jobLogger-sidecar'
import { jobs } from '../behavior/jobs-sidecar'
import { tileMapEditor } from '../editor/tileMapEditor-sidecar'
import { common } from '../main/common-sidecar'
import { scene } from '../main/scene-sidecar'
import { IMonster } from '../monsters/monsters'
import { monsters } from '../monsters/monsters-sidecar'
import { sounds } from '../sounds/sounds-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'
import { cursors } from './cursors-sidecar'
import { pathHighligher } from './pathHighligher-sidecar'

let _selectedMonster: IMonster | null = null

export const create = () => {}

export const select = (monster: IMonster) => {
  _selectedMonster = monster
  updateHighlight(monster)
}

export const update = () => {
  let s = common.getPhaserScene()
  let ctx = scene.getContext()

  if (_selectedMonster && _selectedMonster.isDead) {
    _selectedMonster = null
    cursors.setSelectedToMonster(ctx.cursor, null)
  }

  if (tileMapEditor.getMode() === 'draft') {
    let mx = s.input.mousePointer.x
    let my = s.input.mousePointer.y

    let m = monsters.getAtMouse(mx, my, 1)
    cursors.setSelectedToMonster(ctx.cursor, _selectedMonster)
    if (m && m !== _selectedMonster && !m.isDying) {
      cursors.setWillSelectToMonster(ctx.cursor, m)
    } else {
      cursors.setWillSelectToMonster(ctx.cursor, null)
    }

    if (m) {
      if (clickEater.isPrimaryFirstDownAndUneaten()) {
        if (m !== _selectedMonster) {
          sounds.playSelectMonster()
        }

        select(m)
      }
      cursors.hideCursor(ctx.cursor)
    }
    if (!m) {
      let t = tileMapShip.getTileAtMouse(ctx.mapShip, mx, my)
      //cursors.setSelectedToTile(ctx.cursor, t)
      cursors.setCursorToTile(ctx.cursor, t)
      if (t) {
        // console.log('move it?')
        if (clickEater.isPrimaryFirstDownAndUneaten()) {
          // Move
          // console.log('move it!')
          if (_selectedMonster) {
            if (
              !_selectedMonster.currentJob ||
              !(_selectedMonster.currentJob.type === 'move-to') ||
              _selectedMonster.currentJob.i !== t.i ||
              _selectedMonster.currentJob.j !== t.j
            ) {
              if (_selectedMonster.currentJob) {
                jobLogger.cancelJob(_selectedMonster.currentJob, 'user-cancel')
              }

              let job = jobs.create('move-to')
              job.i = t.i
              job.j = t.j
              job.isInShip = t.dataFloor !== null
              jobs.assignJob(job, _selectedMonster)
            }
            // let sm = _selectedMonster
            // pathHighligher.findPath(
            //   _selectedMonster.i,
            //   _selectedMonster.j,
            //   t.i,
            //   t.j,
            //   _selectedMonster.isInsideShip,
            //   (path) => {
            //     monsters.setPath(sm, path)
            //   },
            // )
          }
        }
      }

      // console.log('found monsters!!', m)
    }
  } else {
    cursors.setCursorToTile(ctx.cursor, null)
    pathHighligher.clearHighlight()
  }
}

export const updateHighlight = (monster: IMonster) => {
  if (_selectedMonster === monster) {
    pathHighligher.highlightPath(monster.path)
  }
}
